/* eslint-disable no-shadow */
import { useCallback, useEffect, useRef, useState } from 'react';
import OAuthService from 'src/app/auth/services/oAuthService';
import oAuthServiceConfig from 'src/app/auth/services/oAuthService/oAuthServiceConfig';
import { useNavigate } from 'react-router-dom';
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import jwtDecode from 'jwt-decode';
import ListPageHeader from '../utilities/ListPageHeader';
import AgGridTable from '../utilities/AgGridTable';
import { useMediaQuery, useTheme } from '@mui/material';
const roleUrl = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.role}`;
const privilegesUrl = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.privileges}`;

export default function Role() {
   const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const gridRef = useRef();
  const stateRef = useRef()
  const [rowData, setRowData] = useState();
  const [error, setError] = useState();
  const [successMsg, setSuccessMsg] = useState();
  const [snackState, setSnackState] = useState(false);
  const [gridApi, setGridApi] = useState(null);
  const [deleteDisable, setDeleteDisable] = useState(true);
  const [selectedRows, setSelectedRows] = useState([]);
  const [stateData, setStateData] = useState({ filter: '', columnState: '', columnGroupState: '' });
  const perPage = 10;
  const navigate = useNavigate();
  // const [allPrivilege, setAllPrivilege] = useState([]);
  const saveGridStateName = 'roleList';
  const token = jwtDecode(localStorage.getItem('token'));
const goToRoleEdit = useCallback(
    (data) => {
      const id = data?._links?.self?.href.split('/').pop();
      if (id) {
        navigate(`/roles/edit/${id}`);
      }
    },
    [navigate],
  );

  const onRowDoubleClicked = (params) => {
    if (isMobile) return; 
    goToRoleEdit(params?.data);
  };

  const onRowClicked = (params) => {
    if (!isMobile) return; 
    goToRoleEdit(params?.data);
  };
  const [columnDefs, setColumnDefs] = useState([
    {
      field: 'displayName',
      headerName: 'Role Name',
      enableRowGroup: true,
      minWidth:100,
    },
    { field: 'privileges', enableRowGroup: true ,minWidth:100,},
  ]);

  const loadData = async (allPrivilege) => {
    try {
      const list = await OAuthService.getList(`${roleUrl}?size=1000`);
      let roles = list.data?._embedded?.roles;
      roles = roles.map((item) => ({
        ...item,
        privileges: item.privileges?.map((privilege) => getPrivilegeData(allPrivilege, privilege)),
      }));
      setRowData(roles);
    } catch (error) {
      setError(error.message);
    }
  };

  const loadPrivileges = async () => {
    try {
      const list = await OAuthService.getList(`${privilegesUrl}?size=1000`);
      const privileges = list.data?._embedded?.privileges;
      // setAllPrivilege(privileges);
      loadData(privileges);
    } catch (error) {
      console.log('error', error);
      setError(error.message);
    }
  };

  const getPrivilegeData = (allPrivilege = [], privilegesID = '') => {
    // console.log(privilegesID, allPrivilege);
    const data = allPrivilege.find((item) => {
      const id = item?._links?.privilege?.href.split('/').pop();
      return id === privilegesID;
    });
    return data?.displayName || privilegesID;
  };

  const onGridReady = useCallback((params) => {
    setGridApi(params.api);
  }, []);

  const onSelectionChanged = (params) => {
    setSelectedRows(params.api.getSelectedRows());
  };

 
  useEffect(() => {
    if (gridApi) {
      // loadData();
      loadPrivileges();
    }
  }, [gridApi]);

  const onBtExport = useCallback(() => {
    const params = {
      fileName: 'RolesList.xlsx',
      sheetName: 'Roles List'
    };
    gridRef.current.api.exportDataAsExcel(params);
  }, []);

  const handlePurge = () => {
    selectedRows.map(async (row) => {
      const id = row?._links?.self?.href.split('/').pop();
      try {
        await OAuthService.deleteData(roleUrl, id);
        setSuccessMsg('Data deleted Successfully');
        setSnackState(true);
        loadData();
      } catch (error) {
        setError(error.message);
      }
    });
  };

  useEffect(() => {
    if (selectedRows.length > 0) {
      setDeleteDisable(false);
    } else {
      setDeleteDisable(true);
    }
  }, [selectedRows]);

  return (
    <>
      <ListPageHeader
        componentName="Role"
        onBtExport={onBtExport}
        addPageLink={token?.scope?.includes("ROLE_ADMIN") ? "/addRole/" : ""}
        pageName="Roles List"
        error={error}
        successMsg={successMsg}
        snackState={snackState}
        gridRef={gridRef}
        // deleteDisable={deleteDisable}
        // handlePurge={handlePurge}
      />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          flex: "1 1 auto",
          minHeight: 0,
          minWidth: 0,
          width: "100%",
        }}
      >
        <div
          style={{
            flex: "1 1 auto",
            minHeight: 400,
            minWidth: 0,
            width: "100%",
            height: isMobile ? "calc(100vh - 200px)" : "calc(100vh - 160px)",
            overflow: "hidden",
          }}
        >
          <AgGridTable
            rowData={rowData}
            columnDefs={columnDefs}
            onGridReady={onGridReady}
            onSelectionChanged={onSelectionChanged}
            onRowDoubleClicked={onRowDoubleClicked}
            onRowClicked={onRowClicked}
            gridRef={gridRef}
            paginationPageSize={perPage}
            cacheBlockSize={perPage}
            saveGridStateName="roleList"
          />
        </div>
      </div>
    </>
  );
}
